import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './i18n'
import './index.css'

// Workaround para traductores del navegador (Google Translate, Safari, Grammarly...)
// que envuelven nodos de texto y rompen la reconciliación de React.
// Ver https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn('Cannot remove a child from a different parent', child, this)
      return child
    }
    return originalRemoveChild.call(this, child) as T
  } as typeof Node.prototype.removeChild

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('Cannot insert before a reference node from a different parent', referenceNode, this)
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  } as typeof Node.prototype.insertBefore
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
